// Invoice-address fields compared on submit to decide whether to send the
// `invoiceAddress` block at all. The backend does not support json-diff/json-path,
// so the client only transmits the address when one of these fields changed
// (also avoids false positives from antd's onChange when a value is re-typed).
const AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS = [
    "companyName",
    "country",
    "firstName",
    "lastName",
    "street",
    "zip",
    "city",
    "companyIdentificationNumber",
    "taxNumber",
    "isSmallBusinessWithoutVatDeclaration",
    "vatId"
];
export { AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS };
